import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseStatistic } from '@mtgame/core';

interface ParamType {
  id: string;
  title: string;
  percent?: boolean;
}

@Component({
  selector: 'mtg-basketball-statistic-leaders',
  templateUrl: './basketball-statistic-leaders.component.html',
  styleUrls: ['../styles/shared.scss', './basketball-statistic-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketballStatisticLeadersComponent implements OnChanges {
  @Input()
  seasonId: number;
  @Input()
  statistic: BaseStatistic[];
  filteredStatistic: BaseStatistic[];

  groups = [
    {
      id: 'points',
      title: 'Результативность',
      params: [
        {
          id: 'points',
          title: 'Очки'
        },
        {
          id: 'assists',
          title: 'Передачи'
        }
      ]
    },
    {
      id: 'shots',
      title: 'Броски',
      params: [
        {
          id: 'threePointsMade',
          title: '3-х очковые',
        },
        {
          id: 'twoPointsMade',
          title: '2-х очковые',
        },
        {
          id: 'freeThrowsMade',
          title: 'Штрафные'
        }
      ]
    },
    {
      id: 'shotsPercent',
      title: 'Процент попаданий',
      params: [
        {
          id: 'threePointPercent',
          title: '3-х очковые',
          percent: true,
        },
        {
          id: 'twoPointPercent',
          title: '2-х очковые',
          percent: true,
        },
        {
          id: 'freeThrowPercent',
          title: 'Штрафные',
          percent: true,
        }
      ]
    },
    {
      id: 'defends',
      title: 'Защитные действия',
      params: [
        {
          id: 'rebounds',
          title: 'Подборы'
        },
        {
          id: 'steals',
          title: 'Перехваты'
        },
        {
          id: 'blocks',
          title: 'Блокшоты'
        }
      ]
    },
    {
      id: 'turnovers',
      title: 'Потери',
      params: [
        {
          id: 'turnovers',
          title: 'Потери'
        },
      ]
    },
    {
      id: 'fouls',
      title: 'Фолы',
      params: [
        {
          id: 'totalFouls',
          title: 'Фолы'
        },
      ]
    }
  ];

  selectedParams: {[key: string]: ParamType} = this.groups.reduce((acc, item) => ({
    ...acc,
    [item.id]: item.params[0]
  }), {});

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredStatistic = this.statistic.filter(item => !item.newbie);
  }
}
